import { Directive, Input } from '@angular/core';

/**
 * The FishCollapse directive provides a simple way to hide and show an element with animations.
 */

export class FishCollapse {
  /**
   * A flag indicating collapsed (true) or open (false) state.
   */
   collapsed = false;
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[fishCollapse]',
  exportAs: 'fishCollapse',
  host: { '[class.collapse]': 'true', '[class.show]': '!collapsed' }
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'collapsed': [{ type: Input, args: ['fishCollapse', ] },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
